import React from "react";
import { interesesDesglosePorPais, interesesMensualesUSD } from "../constants";
import styles from "../stylesER.module.scss";

export const InteresesModal = ({ isOpen, onClose, pais }) => {
  if (!isOpen) return null;

  // Desglose y total leídos de la fuente única de verdad (constants.js).
  // El total mostrado coincide siempre con interesesMensualesUSD[pais].
  const total = interesesMensualesUSD[pais] || 0;
  const formatUSD = (n) => Math.round(n).toLocaleString("es-CL");

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "500px", width: "95%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Detalle de Intereses</h3>
        <table className={styles.modalTable} style={{ marginBottom: "20px" }}>
          <thead>
            <tr>
              <th style={{ width: "60%", textAlign: "left" }}>Concepto</th>
              <th style={{ width: "40%", textAlign: "right" }}>Monto (USD)</th>
            </tr>
          </thead>
          <tbody>
            {interesesDesglosePorPais.map((p) => (
              <tr key={p.nombre}>
                <td style={{ textAlign: "left", fontWeight: "500" }}>{p.nombre}</td>
                <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>US$ {formatUSD(p.montoPais)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: "bold", borderTop: "2px solid #333" }}>
              <td style={{ textAlign: "left" }}>Total</td>
              <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>US$ {formatUSD(total)}</td>
            </tr>
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnCancel} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
